<ng-template #modalTemp let-data>
  <ng-content></ng-content>
  <!-- <ng-content select="tm-modal-header"></ng-content>
  <ng-content select="tm-modal-body"></ng-content>
  <ng-content select="tm-modal-footer"></ng-content> -->
</ng-template>
